import script from "./SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=0483091c&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0483091c"]])

export default __exports__